import { Variants } from '../types/variant';

const pages = {
  CONSULTATION: {
    title: 'Consultation',
    sections: ['CONTEXTE'],
    progressSteps: [1, 2, 4, 6],
  },
  COMPLAINTS: {
    title: 'Motif de consultation',
    sections: ['MOTIF'],
    progressSteps: [
      8, 16, 19, 22, 25, 28, 31, 34, 37, 40, 43, 46, 52, 55, 58, 61, 64, 67, 70,
      73, 76,
    ],
  },
  HISTORY: {
    title: 'Antécédents',
    sections: [
      'ANTECEDENTS', // deprecated after KB PR #846 is deployed
      'ATCD_NV_PATIENT',
      'ANTECEDENTS_GYNECO_NV_PATIENT',
      'ATCD_NV_PATIENT_FOLLOWUP',
      'ATCD_HEADER',
      'ATCD',
      'ANTECEDENTS_GYNECO',
      'ALD_DM',
      'ALLERMED',
      'TRAITEMENTS',
      'ATCD_MISC',
      'MENSURATION',
    ],
    progressSteps: [73, 75, 77, 79, 81, 83],
  },
  PREVENTION: {
    title: 'Prévention',
    sections: [
      'PREVENTION_UPDATE',
      'COMPLETE_PREVENTION',
      'PEDIATRIC_PREVENTION',
      'SCREENING_SPE',
      'PREVENTION_OPTIONAL',
    ],
    progressSteps: [
      84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99,
    ],
  },
  CONCLUSION: {
    title: 'Conclusion',
    sections: ['RECAP'],
    progressSteps: [100],
  },
};

export const neurologieVariants = {
  neurologie: {
    name: 'Neurologie',
    status: 'stable',
    description:
      'Questionnaire pour les patients de neurologie. Couvre les motifs, les antécédents personnels et familiaux du patient ainsi que la prévention.',
    speciality: 'GENERIC-SPE',
    patientOnboarding: 'DEFAULT',
    patientOffboarding: 'DEFAULT',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'MED_G_DEFAULT',
    initialQuestions: [] as string[],
    pages,
    initialAssertions: [
      '[Médecin: #z‹]-(a_spécialité)->[Neurologie]',
      '[Médecin: #z‹]-(a_habilitation)->[EEG]',
      '[Médecin: #z‹]-(a_habilitation)->[EMG]',
    ],
    options: ['COMPACT', 'ALERTES'],
  },
} satisfies Variants;
